import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5704b2e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=c5704b2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5704b2e",
  null
  
)

export default component.exports